<template>
    <div class="form-group">
        <validation-item :label="label" :name="validationFieldName" :rules="rules" :vid="vid">
            <template v-slot="{ validate }">
                <div>
                    <input @input="validate" hidden :value="value">
                    <div @click.self="toggleShowCropper"
                         class="d-flex flex-column border-primary justify-content-center align-items-center"
                         style="border-width:2px;border-style: dashed;border-radius: 5px;padding: 60px;cursor: pointer">
                        <div class="d-flex flex-row flex-wrap">
                        <span v-if="!isMultiple && value!==''"
                              class="d-flex flex-column justify-content-center align-items-center">
                                <img style="width: 60px;border-radius: 10px" :src="value">
                                <span class="text-danger" @click="removeFile(value)">حذف</span>
                        </span>
                            <template v-if="isMultiple && value.length>0">
                            <span :key="image" v-for="image in value"
                                  class="d-flex mx-4 flex-column justify-content-center align-items-center">
                                <img style="width: 60px;border-radius: 10px" :src="image">
                                <span class="text-danger" @click="removeFile(image)">حذف</span>
                            </span>
                            </template>
                        </div>
                        <h6 class="mt-4">برای آپلود فایل کلیک کنید</h6>
                    </div>
                    <cropper
                        v-show="showCropper"
                        field="file"
                        @crop-upload-success="uploadSuccess"
                        :width="300"
                        :height="300"
                        :url="uploadUrl"
                        :params="params"
                        :langExt="langExt"
                        :max-size="maxFilesize"
                        noSquare
                        noCircle
                        v-model="showCropper"
                    ></cropper>
                </div>
            </template>
        </validation-item>
        <span class="text-danger mt-4 w-100 text-center d-block">{{ errorText }}</span>
    </div>
</template>

<script>
import ValidationItem from "./ValidationItem";
import Cropper from 'vue-image-crop-upload/upload-2'

export default {
    name: "ValidationImageCropperUpload",
    components: {ValidationItem, Cropper},
    props: {
        label: {
            type: String,
            default: ''
        },
        validationFieldName: {
            type: String,
            default: ''
        },
        rules: {
            type: [String, Object, Array],
            default: ''
        },
        vid: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'فایل را به اینجا بکشید یا اینجا را کلیک کنید'
        },
        value: {
            type: [Array, String],
            default: ''
        },
        options: {
            type: Object,
            default: function () {
                return {}
            }
        },
        maxFiles: {
            type: Number,
            default: 1
        },
        maxFilesize: {
            type: Number,
            default: 1000
        },
    },
    data() {
        return {
            files: this.value,
            isExistingFileAdded: false,
            cropperImageSrc: '',
            langExt: {
                hint: 'فایل را به اینجا کشیده یا کلیک بکنید',
                loading: 'در حال آپلود …',
                noSupported: 'مرورگر شما از این امکان پشتیبانی نمی کند',
                success: 'آپلود با موفقیت انجام شد',
                fail: 'آپلود شکست خورد',
                preview: 'پیش نمایش',
                btn: {
                    off: 'لغو',
                    close: 'بستن',
                    back: 'بازگشت',
                    save: 'ذخیره'
                },
                error: {
                    onlyImg: 'تنها فرمت تصویری مجاز است',
                    outOfSize: 'حجم تصویر بیش از حد زیاد است؛ حداکثر حجم: ',
                    lowestPx: 'سایز تصویر بیش از اندازه کوچک است؛ حداقل سایز تصویر: '
                }
            },
            params: {
                name: 'file'
            },
            showCropper: false,
            errorText: ''
        }
    },
    computed: {
        isMultiple() {
            return this.maxFiles > 1
        },
        uploadUrl() {
            return process.env.VUE_APP_API_URL + '/upload-image'
        }
    },
    watch: {
        value(newValue) {
            this.files = newValue
        }
    },

    methods: {
        uploadSuccess(response) {
            this.isExistingFileAdded = true
            if (this.isMultiple) {
                this.files.push(response.default)
            } else {
                this.files = response.default
            }
            this.$emit('input', this.files)
        },
        removeFile(file) {
            if (this.isMultiple) {
                this.files.splice(this.files.indexOf(file), 1)
            } else {
                console.log(this.files === file)
                if (this.files === file) this.files = ''
            }
            this.$emit('input', this.files)
        },
        fileAdded(file) {
            this.cropperImageSrc = URL.createObjectURL(file)
        },
        toggleShowCropper() {
            if (this.showCropper) {
                this.showCropper = false
            } else {
                if (this.isMultiple) {
                    if (this.value.length < this.maxFiles) {
                        this.showCropper = true
                    } else {
                        this.errorText = 'متاسفانه نمی توانید فایل های بیشتری آپلود بکنید'
                        this.errorTextHideTimer()
                    }
                } else {
                    this.showCropper = true
                }
            }
        },
        errorTextHideTimer() {
            const app = this
            setTimeout(function () {
                app.errorText = ''
            }, 5000)
        }
    }
}
</script>

<style>
.vue-dropzone > .dz-preview .dz-remove {
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    color: red;
    border: 1px solid transparent;
    margin-left: 0;
    padding: 5px;
}
</style>
